import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('user');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index(
        vuexContext,
        {
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters,
            role = null
        }
    ) {
        return axios.$get('/admin/users', {
            params: {
                page: currentPage,
                perPage,
                q: search,
                sortBy,
                order: descending ? 'DESC' : 'ASC',
                filters: JSON.stringify(filters),
                role
            }
        });
    },

    sendEmail(ctx, { id, subject, message }) {
        return axios.$post(`/admin/users/${id}/send-email`, {
            subject,
            message
        });
    },

    getStarHistory(
        ctx,
        {
            id,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/users/${id}/star-history`, {
            params
        });
    },

    manageStars(ctx, data) {
        return axios.$post(`/admin/users/${data.userId}/manage-stars`, data);
    }
};
